import { TPackages } from '@src/types/packages.ts';
import { AcceptedTerm } from '@src/types/termsAndConditions';

export enum TradingPlatForms {
  CQG_DATA_FEED = 'cqg_data_feed',
  RITHMIC_DATA_FEED = 'rithmic_data_feed',
  // DX_DATA_FEED = 'dx_data_feed',
  CQG_DATA_FEED_2 = 'cqg_data_feed_2',
}

export enum PaymentGateway {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
}

export type BillingInfo = {
  street: string;
  city: string;
  country: string;
  state?: string;
  zip_code?: string;
  phone_number: string;
  first_name: string;
  last_name: string;
};

export type CheckoutInfo = Partial<{
  package_id: number;
  addons?: number[];
  payment_type: string;
  coupon_code: string;
  billing_info: BillingInfo;
}>;

export type OnboardingReq = Partial<{
  trading_platform: TradingPlatForms;
  account_type: string;
  addon_payment_handling_type: string;
  payment_mode: string;
  package_id: number;
  addons: number[];
  payment_gateway: string;
  coupon_code: string;
  additional_charges: string[];
  terms_accepted: AcceptedTerm[];
  referral_source: string;
  billing_info: BillingInfo;
  // Legacy nested structure (kept for compatibility)
  checkout_info: CheckoutInfo;
}>;

export type TOnboardingAccount = Partial<
  TPackages & { selectedAddonIds: number[] }
>;

export type TOnboardingPayment = Partial<{
  terms_accepted: AcceptedTerm[];
  referral_source: string;
  payment_type: string;
  coupon_code: string;
  billing_info: BillingInfo;
}>;

export type DataFeed = {
  id: TradingPlatForms;
  name: string;
  platforms: string[];
  recommended?: boolean;
};
